import FormCompanyImage from 'components/form/FormCompanyImage';
import FormText from 'components/form/FormText';
import FormWysiwygEditor from 'components/form/FormWysiwygEditor';
import type { UseFieldArrayReturn } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import type { FormEditFormStateType } from 'types/page/formEditFormStateType';

import type { JSX } from 'react';

/**
 * フォーム作成編集 完了ページコンポーネント
 */
export default function WsFormEditResults(props: {
  readOnly: boolean;
  fieldArray: UseFieldArrayReturn<FormEditFormStateType, 'results', 'id'>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<FormEditFormStateType>();

  const { fields } = props.fieldArray;

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-form-default section-answer-result">
        <div className="container">
          <div className="box-common">
            <h3 className="title-section">フォーム完了ページ設定</h3>

            {fields.map((field, resultIndex) => {
              return (
                <div key={field.id} className="section-body">
                  <div className="form-default-container">
                    <div className="row row-0">
                      <div className="col-md col-header pt-md-0">
                        <div className="card form-header">
                          <h4 className="title">回答結果用のメイン画像</h4>

                          <FormCompanyImage
                            control={control}
                            name={`results.${resultIndex}.imageKey`}
                            readOnly={props.readOnly}
                          />
                        </div>
                      </div>
                      <div className="col-md col-form ps-md-4 ms-md-2">
                        <div className="form-group mb-md-4">
                          <FormText
                            subject="タイトル"
                            name={`results.${resultIndex}.title`}
                            placeholder="タイトルを入れよう"
                            register={register}
                            errors={errors}
                            maxLength={100}
                            readOnly={props.readOnly}
                          />
                        </div>
                        <div className="form-group">
                          <FormWysiwygEditor
                            control={control}
                            subject="フォームの説明やフィードバック"
                            name={`results.${resultIndex}.descriptionHtml`}
                            placeholder="すべての回答を終えたユーザーに向けた説明文を入れましょう。画像やリンクなども貼り付けることができます。"
                            toolbar={['image', 'link', 'button']}
                            errors={errors}
                            readOnly={props.readOnly}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
